import { jsx as _jsx } from "react/jsx-runtime";
import { LoadingOutlined } from "@ant-design/icons";
import { Button, Result } from "antd";
import { useEffect, useState } from "react";
import { IMPREZA_BUTTON_PROPS } from "../../../components/provider.js";
import { __ } from "../../../utils/i18n.js";
import { getRealCommerceContractClient } from "../../../utils/realCommerceContractClient.js";
const CartAbandonmentOptOut = ({ uuid })=>{
    const [state, setState] = useState("pending");
    const [retryToken, setRetryToken] = useState(0);
    useEffect(()=>{
        let cancelled = false;
        (async ()=>{
            const client = getRealCommerceContractClient();
            const result = await client.checkout.cartAbandonmentEmailBlacklist.post({
                request: {
                    checkout: {
                        uuid
                    }
                }
            });
            if (cancelled) {
                return;
            }
            switch(result.status){
                case 200:
                    setState(result.response.alreadyOptedOut ? "alreadyOptedOut" : "success");
                    break;
                case 404:
                    setState("notFound");
                    break;
                default:
                    setState("error");
            }
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        uuid,
        retryToken
    ]);
    if (state === "pending") {
        return /*#__PURE__*/ _jsx(Result, {
            icon: /*#__PURE__*/ _jsx(LoadingOutlined, {}),
            title: __("Unsubscribing...")
        });
    }
    if (state === "success") {
        return /*#__PURE__*/ _jsx(Result, {
            status: "success",
            title: __("You are unsubscribed."),
            subTitle: __("Thank you - we will not follow up on unfinished checkouts anymore.")
        });
    }
    if (state === "alreadyOptedOut") {
        return /*#__PURE__*/ _jsx(Result, {
            status: "info",
            title: __("You are already unsubscribed."),
            subTitle: __("All set - we will not follow up on unfinished checkouts.")
        });
    }
    if (state === "notFound") {
        return /*#__PURE__*/ _jsx(Result, {
            status: "warning",
            title: __("We could not find this checkout."),
            subTitle: __("The link may have expired or already been processed.")
        });
    }
    return /*#__PURE__*/ _jsx(Result, {
        status: "error",
        title: __("Something went wrong on our end - we are sorry."),
        subTitle: __("We could not unsubscribe you right now. Please try again in a moment, or reach out to our support team and we will take care of it for you."),
        extra: /*#__PURE__*/ _jsx(Button, {
            type: "primary",
            onClick: ()=>{
                setState("pending");
                setRetryToken((token)=>token + 1);
            },
            ...IMPREZA_BUTTON_PROPS,
            children: __("Try again")
        })
    });
};
export { CartAbandonmentOptOut };
